module.exports = __webpack_public_path__ + "files/ef8d245d2f2d7ad25c2669d6327ca39f.png";